import { render } from "./ImportModule.vue?vue&type=template&id=e3ab4d84&ts=true"
import script from "./ImportModule.vue?vue&type=script&lang=ts"
export * from "./ImportModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__